
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// component function
import * as ComponentFuntions from './Consumption.Settlement.Functions';

// Fluent UI
import { Body1Strong, Button, Caption1, Spinner } from '@fluentui/react-components';
import { DocumentOnePage24Regular, Open20Regular } from '@fluentui/react-icons';

// styles
import './Consumption.Settlement.Styles.css';

const ConsumptionSettlementComponent = (props: ComponentFuntions.Props) => {

    useEffect(() => {
        props.GetProtocolConsumptionById(props.ProtocolId, props.ProtocolConsumptionId);
    }, [props.Consumption?.id === undefined]);

    useEffect(() => {
        props.Consumption?.settlementId && props.GetSettlementById(props.Consumption.settlementId);
    }, [props.Consumption?.settlementId === undefined]);

    return (
        <div className='consumption-settlement-container'>
            {props.isLoading && <Spinner size="extra-tiny" />}
            {props.Settlement &&
                <>
                    <DocumentOnePage24Regular />
                    <div>
                        <Body1Strong>{props.Settlement.name}</Body1Strong>
                        <Caption1 style={{ color: 'var(--colorNeutralForeground3)' }}>
                            {props.Settlement?.identifier}
                        </Caption1>
                    </div>
                    <Button
                        as="a"
                        href={'../settlements/' + props.Settlement?.id}
                        target="_blank"
                        rel="noopener noreferrer"
                        appearance="outline"
                        size="small"
                        style={{ marginLeft: 'auto' }}
                    >
                        Ver liquidación
                    </Button>
                </>
            }
        </div>
    );

};

export default connect(
    ComponentFuntions.mapStateToProps,
    ComponentFuntions.mapDispatchToProps
)(ConsumptionSettlementComponent as any);